<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-input v-model="formDatas.userName" style="width: 200px;" size="small" placeholder="用户名称"
                        clearable></el-input>
                   
                   <el-select v-model="formDatas.aatuStatus" clearable placeholder="状态" @change="partserch"
                        size="small" style="width: 140px">
                        <el-option label="未处理" value="1" key="1"></el-option>
                        <el-option label="已完成 " value="2" key="2"></el-option>
                        <el-option label="失败" value="3" key="3"></el-option>
                    </el-select>
                    <el-button type="info" size="small" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                    <!-- <el-button type="success" size="small" style="margin-right: 20px" @click="BoxOpen">新增部门</el-button> -->

                    <el-button type="warning" size="small" style="margin-right: 10px;"
                        @click="FXXKuser">拉取数据</el-button>
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption"
                        row-key-field-name="aatuId" :cellSelectionOption="cellSelectionOption" style="width: 100%"
                        :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 新增 -->
            <el-drawer :wrapperClosable="false" :title="edit == true ? '编辑部门' : '新增部门'" :before-close="handleClose"
                :visible.sync="dialog" direction="rtl" custom-class="demo-drawer" ref="drawer">
                <div class="demo-drawer__content" style="height: 90%;">
                    <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
                        <div
                            style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                            <el-form-item label="是否有下级" prop="fddChildHas">
                                <el-radio-group v-model="form.fddChildHas">
                                    <el-radio :label="1">否</el-radio>
                                    <el-radio :label="2">是</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <div class="demo-drawer__footer" style="margin-top: 10px;">
                    <el-button @click="handleClose()" style="margin-left: 20%;">取 消</el-button>
                    <el-button type="primary" @click="SureBtn" style="margin-left: 150px;">
                        确 定</el-button>
                </div>
            </el-drawer>
        </div>
    </div>
</template>

<script>

import { getAjAttendanceTableUserList, updateAjAttendanceTableUserSync, } from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            props: {
                value: 'id',
                label: 'name',
                children: 'child',
            },
            departmentArr: [],
            dialog: false,
            edit: false,
            form: {
                aacName: '',
            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: false,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 20,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,
            columns: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "auName",
                    key: "auName",
                    fixed: 'left',
                    title: "用户名称",
                    align: "center",
                    width: 100,
                },
                {
                    field: "aatuYearMonth",
                    key: "aatuYearMonth",
                    title: "年月",
                    align: "center",
                    fixed: 'left',
                    width: 80,
                    edit: false,
                },
                {
                    field: "aatuDay",
                    key: "aatuDay",
                    title: "日",
                    fixed: 'left',
                    align: "center",
                    width: 60,
                },
                {
                    field: "aatuStatus",
                    key: "aatuStatus",
                    title: "状态(1未处理 2已完成 3失败)",
                    align: "center",
                    width: 100,
                },
                {
                    field: "dingUserId",
                    key: "dingUserId",
                    title: "用户钉钉id",
                    align: "center",
                    width: 170,
                    edit: false,
                },
                
                {
                    field: "aatuClasses",
                    key: "aatuClasses",
                    title: "班次",
                    align: "center",
                    width: 130,
                },
                  {
                    field: "aatuClockIds",
                    key: "aatuClockIds",
                    title: "打卡记录ids",
                    align: "center",
                    width: 130,
                },
                {
                    field: "aatuClockOneBase",
                    key: "aatuClockOneBase",
                    title: "上班应打卡时间",
                    align: "center",
                    width: 100,
                },
                 {
                    field: "aatuClockOne",
                    key: "aatuClockOne",
                    title: "上班打卡时间",
                    align: "center",
                    width: 100,
                },
                {
                    field: "aatuClockOneResult",
                    key: "aatuClockOneResult",
                    title: "上班打卡结果",
                    align: "center",
                    width: 100,
                },
                 {
                    field: "aatuClockTwoBase",
                    key: "aatuClockTwoBase",
                    title: "下班应打卡时间",
                    align: "center",
                    width: 100,
                },
                {
                    field: "aatuClockTwo",
                    key: "aatuClockTwo",
                    title: "下班打卡时间",
                    align: "center",
                    width: 100,
                },
                {
                    field: "aatuClockTwoResult",
                    key: "aatuClockTwoResult",
                    title: "下班打卡结果",
                    align: "center",
                    width: 100,
                },
                {
                    field: "aatuApplyIds",
                    key: "aatuApplyIds",
                    title: "审批单ids",
                    align: "center",
                    width: 200,
                },
                {
                    field: "aatuApplyOne",
                    key: "aatuApplyOne",
                    title: "出差记录",
                    align: "center",
                    width: 200,
                },
                {
                    field: "aatuApplyTwo",
                    key: "aatuApplyTwo",
                    title: "加班记录",
                    align: "center",
                    width: 200,
                },
                {
                    field: "aatuApplyThree",
                    key: "aatuApplyThree",
                    title: "请假记录",
                    align: "center",
                    width: 200,
                },
                {
                    field: "aatuApplyFour",
                    key: "aatuApplyFour",
                    title: "外出记录",
                    align: "center",
                    width: 200,
                },
                {
                    field: "aatuApplyFive",
                    key: "aatuApplyFive",
                    title: "居家记录",
                    align: "center",
                    width: 200,
                },
                {
                    field: "aatuApplySix",
                    key: "aatuApplySix",
                    title: "补卡记录",
                    align: "center",
                    width: 200,
                },
                {
                    field: "aatuApplySixTwo",
                    key: "aatuApplySixTwo",
                    title: "补卡记录",
                    align: "center",
                    width: 200,
                },
                {
                    field: "aatuApplyDes",
                    key: "aatuApplyDes",
                    title: "审批单描述",
                    align: "center",
                    width: 200,
                },
                {
                    field: "aatuApplyAddBill",
                    key: "aatuApplyAddBill",
                    title: "加班审批时长",
                    align: "center",
                    width: 100,
                },
                {
                    field: "aatuApplyAddUser",
                    key: "aatuApplyAddUser",
                    title: "加班实际时长",
                    align: "center",
                    width: 100,
                },
                {
                    field: "aatuLengthLate",
                    key: "aatuLengthLate",
                    title: "迟到时长(分)",
                    align: "center",
                    width: 100,
                },
                {
                    field: "aatuLengthEarly",
                    key: "aatuLengthEarly",
                    title: "早退时长(分)",
                    align: "center",
                    width: 100,
                },
                {
                    field: "aatuLengthAbsentee",
                    key: "aatuLengthAbsentee",
                    title: "旷工天数",
                    align: "center",
                    width: 100,
                },
                {
                    field: "aatuLengthOut",
                    key: "aatuLengthOut",
                    title: "外出时长",
                    align: "center",
                    width: 100,
                },
                {
                    field: "aatuStatusReal",
                    key: "aatuStatusReal",
                    title: "最终结果(1正常 2异常)",
                    align: "center",
                    fixed: 'right',
                    width: 100,
                },
                {
                    field: "aatuStatusRealDes",
                    key: "aatuStatusRealDes",
                    title: "异常描述",
                    align: "center",
                    fixed: 'right',
                    width: 150,
                },
                {
                    field: "createtime",
                    key: "createtime",
                    title: "创建时间",
                    align: "center",
                    fixed: 'right',
                    width: 180,
                },

            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                aatuYearMonth: "" ,
                syncStatusInit: "",
                syncStatus: "",
                syncStatusZaitu: "",
                syncStatusJindie: "",
                dmDelete: 1,
                currentPage: 1,
                pageSize: 10,
            },
        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        this.getList();
    },
    mounted() { },
    methods: {
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
        },
        FXXKuser() {
            this.openLoading()
            //{ aatuYearMonth: 202505 }
            updateAjAttendanceTableUserSync().then(res => {
                this.loadings.close()
                if (res) {
                    this.$message({
                        type: "success",
                        message: "获取成功!",
                    });
                    this.partserch()
                }
            })
        },
        cascaderChange(e) {
            console.log(e);
            this.formDatas.mainDepartmentId = e[e.length - 1];
            this.partserch()
        },
        handleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    const s = { aatuId: row.aatuId }
                    console.log(s);
                    deleteAjUserDepartment({ aatuId: row.aatuId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {
                this.form = data;
            })
        },
        SureBtn() {
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        addAjUserDepartment(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        updateFxxkDingDepartment(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        BoxOpen() {
            this.dialog = true;

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.$refs['formRef'].resetFields();
        },
        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.aatuId = row.aatuId
                    console.log(jsonObj);
                    updateFxxkDingDepartment(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys() {
            console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item.aatuId) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item.aatuId);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys) {
            console.log(isSelected, selectedRowKeys);
            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item.aatuId) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item.aatuId), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected) {
            const rowKey = row.aatuId;

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getAjAttendanceTableUserList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys();
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });

        },
        partserch() {
             this.openLoading()
            this.formDatas.currentPage = 1;
            getAjAttendanceTableUserList(this.formDatas).then((res) => {
                this.loadings.close()
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys();
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });
        },
        getList() {
              this.openLoading()
            getAjAttendanceTableUserList(this.formDatas).then((res) => {
                this.loadings.close()
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}

.ve-table .ve-table-container .ve-table-content-wrapper table.ve-table-content tbody.ve-table-body .ve-table-expand-tr .ve-table-expand-td-content {
    padding: 0 !important;
}
</style>